import React, { forwardRef, useImperativeHandle, useState } from "react";
import Modal from "react-modal";
import modalCustomStyles from "../../util/modalCustomStyles";
import CloseIcon from "../icons/CloseIcon";

const Alert = forwardRef(
  ({
    title, message, type = "info", onConfirm, onCancel, ...props
  }, alertRef) => {
    const [isOpen, setIsOpen] = useState(false);
    const closedClass = type === "confirm" ? "btn--outline-dark" : "btn--dark";

    const toggleAlert = () => {
      setIsOpen(!isOpen);
    };

    useImperativeHandle(alertRef, () => ({
      toggleAlert,
    }));

    const handleConfirm = () => {
      if (onConfirm) {
        onConfirm();
      }
      toggleAlert();
    };

    const handleCancel = () => {
      toggleAlert();
      if (onCancel) {
        onCancel();
      }
    };

    return (
      <Modal
        isOpen={isOpen}
        style={{
          ...modalCustomStyles(window.innerWidth < 768, {
            width: "400px",
            height: "auto",
            top: "200px"
          })
        }}
        ariaHideApp={false}
      >
        {type === "info" && (
          <div className="d-flex justify-content-end ml-20">
            <span className="h-10 cursor-pointer" onClick={handleCancel}>
              <CloseIcon className="fill-dark w-12" />
            </span>
          </div>
        )}
        <div className="d-flex">
          <span className="modal-title fs-18 pb-5">{title}</span>
        </div>

        <div className="d-flex text-secondary fz-14">{message}</div>
        {props.children}

        <div className="d-flex justify-content-end mt-20">
          <button
            type="button"
            className={`btn ${closedClass}`}
            onClick={handleCancel}
          >
            Cerrar
          </button>
          {type === "confirm" && (
            <button
              type="button"
              className="btn btn--danger"
              onClick={handleConfirm}
            >
              Confirmar
            </button>
          )}
        </div>
      </Modal>
    );
  }
);

export default Alert;
